export const cleanObject = (data, excluded = []) => {
  return Object.keys(data).reduce((obj, key) => {
    const value = data[key];
    if (value !== null && value !== "" && !excluded.includes(value)) {
      obj[key] = value;
      return obj;
    }
    return obj;
  }, {});
};
